<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="build" alt="build" src="../../assets/images/build-category-icon.svg"/>
    </template>
    <template slot="message">
      <p>Your inquiry has been sent!<br />
        Thank you for your interest in Lerner Maker Lab!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'ContactUsAcknowledge',

    components: {
      Acknowledge,
    },

    data: function () {
      return {
        headline: 'Nailed it!',
      }
    }
  };
</script>